module.exports = __webpack_public_path__ + "img/inqli-logo-dark.7fc6e462.svg";